import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VesselItemPayload, VesselItemResponse } from "@/types/interface/item-vessel";

export const useVesselItemStore = defineStore("vesselItemStore", () => {
  const vesselItem = ref<VesselItemResponse>();
  const vesselItems = ref<VesselItemResponse[]>([]);

  function initVesselItems(data: any) {
    vesselItems.value = data?.data;
  }

  function addNewVesselItem(data: any) {
    vesselItem.value = data;
  }

  async function dispatchGetList(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.getList(page, limit, queryParam);
      initVesselItems(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchDetail(idItem = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.find(idItem);
      addNewVesselItem(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchSpecificDetail(queryParams: string) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.specificItem(queryParams);
      addNewVesselItem(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchCreate(payload: VesselItemPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.create(payload);
      addNewVesselItem(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchUpdate(idItem = "", payload: VesselItemPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.update(idItem, payload);
      addNewVesselItem(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchDelete(idItem = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselItem.remove(idItem);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  return {
    vesselItem,
    vesselItems,
    initVesselItems,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchSpecificDetail,
    dispatchGetList,
    dispatchDelete
  };
});